import { matchesAdapterAnswers } from "../helpers";
import type { AdapterAnswerCondition, AdapterApplyAnswers } from "../types";
import type { ResourceOwner } from "./types";

/** Whether a resource applies: its step's, its block's and its own `showWhen` must all match the answers. */
export const isResourceApplicable = (
  answers: AdapterApplyAnswers,
  owner: ResourceOwner,
  resource: object,
): boolean =>
  [...owner.conditions, (resource as { showWhen?: AdapterAnswerCondition }).showWhen].every((condition) =>
    matchesAdapterAnswers(answers, condition));
